import { EndCondition, ModelCategory } from '@paragon/contract-library';

import { ModelSchema } from '../ModelSchema';
import { BooleanProperty } from '../properties/BooleanProperty';

export const EndConditionSchema = new ModelSchema<EndCondition>('endCondition', {
  category: ModelCategory.ComponentDesignData,
  properties: {
    isTopChordBearing: BooleanProperty,
  },
});
